// src/pages/VerificarCertificadoPage.js — Verificación pública de certificados
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { certificadoService, BACKEND_BASE } from '../services/api';
import { fmtFechaBogota } from '../utils/fecha';

const Container = styled.div`
  max-width: 600px;
  margin: 3rem auto;
  padding: 2rem;
  font-family: 'Segoe UI', sans-serif;
  text-align: center;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 24px rgba(0,0,0,0.1);
  border-top: 4px solid ${p => p.$valid ? '#059669' : '#dc2626'};
`;

const StatusIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const StatusText = styled.h2`
  color: ${p => p.$valid ? '#059669' : '#dc2626'};
  margin: 0 0 1rem;
`;

const InfoLabel = styled.p`
  color: #6b7280;
  font-size: 0.85rem;
  margin: 0.25rem 0;
`;

const InfoValue = styled.p`
  color: #1f2937;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem;
`;

const Logo = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 1rem;
`;

const VerificarCertificadoPage = () => {
  const { codigo } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!codigo) return;
    certificadoService.verificar(codigo)
      .then(res => setResult(res.data))
      .catch(() => setResult({ valido: false }))
      .finally(() => setLoading(false));
  }, [codigo]);

  if (loading) return <Container><p>Verificando certificado...</p></Container>;

  if (!result) return <Container><p>Error al verificar.</p></Container>;

  return (
    <Container>
      <Card $valid={result.valido}>
        <StatusIcon>{result.valido ? '\u2705' : '\u274C'}</StatusIcon>
        <StatusText $valid={result.valido}>
          {result.valido ? 'Certificado Válido' : 'Certificado No Encontrado'}
        </StatusText>

        {result.valido && (
          <>
            {result.proyecto_logo && (
              <Logo src={`${BACKEND_BASE}/${result.proyecto_logo}`} alt="" />
            )}
            <InfoLabel>Otorgado a</InfoLabel>
            <InfoValue>{result.nombre}</InfoValue>

            <InfoLabel>Proyecto</InfoLabel>
            <InfoValue>{result.proyecto}</InfoValue>

            <InfoLabel>Fecha de emisión</InfoLabel>
            <InfoValue>{fmtFechaBogota(result.fecha_emision, { year: 'numeric', month: 'long', day: 'numeric' })}</InfoValue>

            {result.contenidos && result.contenidos.length > 0 && (
              <>
                <InfoLabel>Contenidos completados</InfoLabel>
                <InfoValue>{result.contenidos.map(c => c.titulo).join(', ')}</InfoValue>
              </>
            )}
          </>
        )}

        {!result.valido && (
          <p style={{ color: '#6b7280', marginTop: '1rem' }}>
            El código de verificación ingresado no corresponde a ningún certificado emitido.
          </p>
        )}
      </Card>
    </Container>
  );
};

export default VerificarCertificadoPage;
